import React, { FunctionComponent } from 'react'

import { Text as ThmeUiText } from '@theme-ui/components'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Text } from '@fairhq/common'
import { StateHandler } from 'components/StateHandler'
import { Layout } from 'layout/Layout'

import { useGetAssessmentChangesQuery } from 'store/audit/auditApiWithQuery'
import { Separator } from 'ui-kit/Separator'

import { AssessmentChange } from './ChangelogItem'

const List = styled.ul`
  padding-left: 20px;
  margin-bottom: 0;
`

export const AssessmentChanges: FunctionComponent = () => {
  const { t } = useTranslation()

  const {
    data: assessmentChanges,
    isLoading,
    isError,
    isSuccess,
  } = useGetAssessmentChangesQuery()

  return (
    <Layout maxContentWidth={1080} dark>
      <StateHandler
        isSuccess={isSuccess}
        isLoading={isLoading}
        isError={isError}
        errorMessage={t('error.somethingWrong.fallback')}
      >
        <Text fontWeight={700} size="xl" element="h1" type="heading">
          {t('settings.assessment.title')}
        </Text>

        <ThmeUiText as="div" sx={{ maxWidth: 640, mb: 5 }}>
          {t('settings.assessment.description')}
        </ThmeUiText>
        {assessmentChanges && assessmentChanges.length === 0 && (
          <ThmeUiText as="div">{t('settings.assessments.empty')}</ThmeUiText>
        )}
        {assessmentChanges && assessmentChanges.length > 0 && (
          <List>
            {assessmentChanges.map((change, index) => (
              <AssessmentChange key={index} change={change} />
            ))}
          </List>
        )}
        <Separator />
        <ThmeUiText as="div" sx={{ maxWidth: 640, mb: 5 }}>
          {t('settings.assessment.footnote')}
        </ThmeUiText>
      </StateHandler>
    </Layout>
  )
}
